import { RedeemType } from "../enums/redeem-type.enum";

export class CustomRedeemWindow {
  public type: RedeemType;
  public dayOfEventBeginTime: string;
  public dayOfEventEndTime: string;
  public daysAfterEvent: number;
  constructor(type: RedeemType, begin?: string, end?: string, after?: number) {
    this.type = type;
    this.dayOfEventBeginTime = begin ? begin : null;
    this.dayOfEventEndTime = end ? end : null;
    this.daysAfterEvent = after ? after : null;
  }

  toJSON() {
    return {
      type: this.type,
      dayOfEventBeginTime: this.dayOfEventBeginTime,
      dayOfEventEndTime: this.dayOfEventEndTime,
      daysAfterEvent: this.daysAfterEvent
    };
  }
}
